export enum OnboardingSection {
  onboardingCases = 'onboarding_cases',
  onboardingInfo = 'onboarding_info',
}
